import { PicklistResultV2 } from "../../PicklistApiClient/Types/PicklistResultV2";

import { DigestRequest } from "./Types/DigestRequest";

export interface IDigestApiClient {
    getDigest(request: Readonly<DigestRequest>): Promise<PicklistResultV2>;
}
